import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "mdm_admin_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function adminLogin(email, password) {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.access_token);
  return data;
}

export async function adminMe() {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeaders() });
  return data;
}

export async function adminGet(path) {
  const { data } = await axios.get(`${API}${path}`, { headers: authHeaders() });
  return data;
}

export async function adminPost(path, body = {}) {
  const { data } = await axios.post(`${API}${path}`, body, {
    headers: authHeaders(),
  });
  return data;
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return err?.message || "Errore di rete.";
}
